document.addEventListener("DOMContentLoaded", () => {
  const initializeCollapsibleCards = () => {
    const collapsibleCards = document.querySelectorAll(".collapsible-card");

    collapsibleCards.forEach((card) => {
      const cardGrid = card.querySelector(".card-grid");
      const plusButton = card.querySelector(".plus-button");
      const minusButton = card.querySelector(".minus-button");
      const cardHeading = card.querySelector(".card-heading");

      let isExpanded = false;
      card.classList.add("collapsed");

      card.expandCard = () => {
        if (!isExpanded) {
          expandCard(card, cardGrid);
          isExpanded = true;
        }
      };

      card.collapseCard = () => {
        if (isExpanded) {
          collapseCard(card, cardGrid);
          isExpanded = false;
        }
      };

      minusButton.addEventListener("click", (event) => {
        event.stopPropagation();
        if (isExpanded) {
          collapseCard(card, cardGrid);
          isExpanded = false;
        }
      });

      plusButton.addEventListener("click", (event) => {
        event.stopPropagation();
        if (!isExpanded) {
          expandCard(card, cardGrid);
          isExpanded = true;
          scrollCardIntoView(card);
        }
      });

      cardHeading.addEventListener("click", () => {
        if (isExpanded) {
          collapseCard(card, cardGrid);
          isExpanded = false;
        } else {
          expandCard(card, cardGrid);
          isExpanded = true;
          scrollCardIntoView(card);
        }
      });
    });
  };

  // 200px clears the fixed header plus the notch tab that overhangs the
  // card top (same offset the ?card= deep-link scroll uses below)
  const scrollCardIntoView = (card) => {
    const offsetTop = card.getBoundingClientRect().top + window.scrollY - 200;

    window.scrollTo({
      top: offsetTop,
      behavior: "smooth",
    });
  };

  const collapseCard = (card, cardGrid) => {
    const currentHeight = cardGrid.scrollHeight;
    cardGrid.style.height = currentHeight + "px";

    cardGrid.offsetHeight;

    card.classList.add("collapsed");
    cardGrid.style.height = "0px";
  };

  const expandCard = (card, cardGrid) => {
    cardGrid.style.height = "auto";
    const fullHeight = cardGrid.scrollHeight;

    cardGrid.style.height = "0px";

    cardGrid.offsetHeight;

    card.classList.remove("collapsed");
    cardGrid.style.height = fullHeight + "px";

    setTimeout(() => {
      cardGrid.style.height = "auto";
    }, 300);
  };

  const handleUrlCardParameter = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const cardTitle = urlParams.get("card");

    if (!cardTitle) return;

    const normalizedUrlTitle = decodeURIComponent(cardTitle)
      .toLowerCase()
      .trim();

    const collapsibleCards = document.querySelectorAll(".collapsible-card");
    let targetCard = null;

    collapsibleCards.forEach((card) => {
      const dataCardTitle = card.getAttribute("data-card-title");
      if (
        dataCardTitle &&
        dataCardTitle.toLowerCase() === normalizedUrlTitle.replace(/\s+/g, "-")
      ) {
        targetCard = card;
        return;
      }

      const cardTitleElement = card.querySelector(".card-title");
      if (cardTitleElement) {
        const cardTitleText = cardTitleElement.textContent.toLowerCase().trim();

        if (
          cardTitleText === normalizedUrlTitle ||
          cardTitleText.includes(normalizedUrlTitle)
        ) {
          targetCard = card;
        }
      }
    });

    if (targetCard) {
      setTimeout(() => {
        const offsetTop = targetCard.offsetTop - 200;

        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });

        setTimeout(() => {
          if (targetCard.expandCard) {
            targetCard.expandCard();
          }
        }, 800);
      }, 400);
    }
  };

  // Fan the notch tabs evenly from the first card (flush left) to the last
  // (at the right clamp), so every card steps a little further right instead
  // of the last few bunching at the same position. Works for any card count.
  const positionCollapsibleNotches = () => {
    document.querySelectorAll(".collapsible-cards").forEach((container) => {
      const cards = container.querySelectorAll(".collapsible-card-parent");

      // Notches on cards 1..last spread progress 0..1 evenly; the last card
      // lands exactly on --notch-end (the right clamp).
      const denom = cards.length - 2;

      cards.forEach((card, index) => {
        if (index === 0) return;
        const progress = denom <= 0 ? 1 : (index - 1) / denom;
        card.style.setProperty("--notch-progress", progress.toFixed(4));
      });
    });
  };

  initializeCollapsibleCards();

  positionCollapsibleNotches();

  handleUrlCardParameter();
});
